export default "__VITE_ASSET__uiluJGf3__"